import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getOrder } from '../services/api';

export default function OrderDetail() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    getOrder(id).then((data) => setOrder(data));
  }, [id]);

  if (!order) return <p className="text-center py-10 text-neutral-400">جار التحميل...</p>;

  return (
    <div className="max-w-4xl mx-auto text-white">
      <Link to="/orders" className="text-red-500 font-bold mb-6 inline-block">← العودة للطلبات</Link>
      <div className="bg-neutral-950 p-8 rounded-2xl border border-neutral-800 mt-4">
        <h2 className="text-2xl font-black mb-6">تفاصيل الطلب #{order.id}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          <p><strong className="text-neutral-400">العميل:</strong> {order.customer_name}</p>
          <p><strong className="text-neutral-400">الهاتف:</strong> {order.phone}</p>
          <p><strong className="text-neutral-400">العنوان:</strong> {order.address}, {order.city} {order.zip_code}</p>
          <p><strong className="text-neutral-400">الحالة:</strong> <span className="text-red-500 font-bold">{order.status}</span></p>
          <p><strong className="text-neutral-400">التاريخ:</strong> {new Date(order.created_at).toLocaleString('ar-SA')}</p>
          <p><strong className="text-neutral-400">ملاحظات:</strong> {order.notes || 'لا يوجد'}</p>
        </div>

        <h3 className="text-xl font-bold mb-4 border-b border-neutral-800 pb-2">المنتجات</h3>
        <table className="w-full text-right">
          <thead className="text-neutral-400">
            <tr className="border-b border-neutral-800">
              <th className="p-2">المنتج</th>
              <th className="p-2">الكمية</th>
              <th className="p-2">السعر</th>
              <th className="p-2">الإجمالي</th>
            </tr>
          </thead>
          <tbody>
            {order.items.map((item, idx) => (
              <tr key={idx} className="border-b border-neutral-800">
                <td className="p-2">{item.product_name}</td>
                <td className="p-2">{item.quantity}</td>
                <td className="p-2">{item.price} شيكل</td>
                <td className="p-2">{item.quantity * item.price} شيكل</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="text-left text-xl font-black mt-4">المجموع الكلي: {order.total} شيكل</p>
      </div>
    </div>
  );
}